import { supabase } from './supabaseClient';

/** Marketing tables via the signed-in staff session (never service_role). */
export const marketingAdmin = supabase;

export const MARKETING_SITE_URL =
  process.env.REACT_APP_MARKETING_SITE_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:3010' : 'https://app.roadserve.in');

export function marketingBlogPostUrl(slug, status = 'published') {
  const base = MARKETING_SITE_URL;
  if (status === 'draft') {
    return `${base}/blog/${slug}?preview=1`;
  }
  return `${base}/blog/${slug}`;
}

/**
 * Blog generate/cover APIs live under /api/cron/* on the marketing site.
 * Dev: CRA proxy `/api/marketing` → localhost:3010/api (avoids CORS).
 * Prod: call https://app.roadserve.in/api/... directly (CORS allows roadserve.astric.ai).
 */
export const MARKETING_API_BASE =
  process.env.NODE_ENV === 'development'
    ? '/api/marketing'
    : `${String(MARKETING_SITE_URL).replace(/\/$/, '')}/api`;

/**
 * Auth for marketing-site admin APIs: send the signed-in staff user's Supabase
 * access token. The marketing site verifies it via is_admin_or_supervisor().
 * (Never embed CRON_SECRET / service_role in this client bundle.)
 */
export async function marketingAdminAuthHeader() {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export function marketingGenerateBlogUrl() {
  return `${MARKETING_API_BASE}/cron/generate-blog`;
}

export function marketingGenerateWaTemplateUrl() {
  return `${MARKETING_API_BASE}/cron/generate-wa-template`;
}

export function marketingRegenerateCoverUrl() {
  return `${MARKETING_API_BASE}/cron/regenerate-cover`;
}

export function marketingShortLinkUrl(code) {
  const base = MARKETING_SITE_URL.replace(/\/$/, '');
  return `${base}/go/${encodeURIComponent(String(code || '').trim().toLowerCase())}`;
}
